// src/components/BotaoAtivarDesativarMotorista.tsx
import React, { useState } from 'react';
import axios from 'axios';

interface BotaoAtivarDesativarMotoristaProps {
    motoristaId: number;
    ativo?: boolean | null;
    onStatusChange?: (novoStatus: boolean) => void;
}

const BASE_URL = process.env.REACT_APP_API_URL;

const BotaoAtivarDesativarMotorista: React.FC<BotaoAtivarDesativarMotoristaProps> = ({
    motoristaId,
    ativo,
    onStatusChange,
}) => {
    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {
        if (loading) return;

        setLoading(true);
        try {
            const novoStatus = !(ativo ?? true);
            await axios.put(`${BASE_URL}/motorista/${motoristaId}/ativo`, {
                ativo: novoStatus,
            });

            if (onStatusChange) {
                onStatusChange(novoStatus);
            }
        } catch (err) {
            console.error("Erro ao atualizar status do motorista:", err);
            alert("Erro ao atualizar status do motorista");
        } finally {
            setLoading(false);
        }
    };

    const isAtivo = ativo ?? true;
    const buttonClass = isAtivo ? "btn btn-danger" : "btn btn-success";
    const label = isAtivo ? "Desativar motorista" : "Ativar motorista";

    return (
        <button
            className={buttonClass}
            onClick={handleToggle}
            disabled={loading}
            style={{ minWidth: 180 }}
        >
            {loading ? "Aguarde..." : label}
        </button>
    );
};

export default BotaoAtivarDesativarMotorista;
